import { render, staticRenderFns } from "./MobileComponent.vue?vue&type=template&id=a0a4d870&scoped=true&"
import script from "./MobileComponent.vue?vue&type=script&lang=js&"
export * from "./MobileComponent.vue?vue&type=script&lang=js&"
import style0 from "./MobileComponent.vue?vue&type=style&index=0&id=a0a4d870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a4d870",
  null
  
)

export default component.exports